module.exports = __webpack_public_path__ + "static/media/insta1.e8811035.jpg";